<!-- design-lint-disable no-date-parse (the shared list-cell renderer: date-only values are read as a local calendar day) -->
<script>
  // Formats a date value. Column may set `format`: 'date' (default) | 'datetime' | 'relative'.
  let { value, column = {} } = $props()

  const format = (v) => {
    if (!v) return null
    // A date-only value ("2026-11-05") is a calendar day, not UTC midnight: `new Date` would show
    // the day before anywhere west of UTC.
    const day = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(v))
    const d = day ? new Date(Number(day[1]), Number(day[2]) - 1, Number(day[3])) : new Date(v)
    if (Number.isNaN(d.getTime())) return String(v)
    if (column.format === 'datetime') return d.toLocaleString()
    if (column.format === 'relative') {
      const days = Math.round((Date.now() - d.getTime()) / 86_400_000)
      if (days === 0) return 'Today'
      if (days === 1) return 'Yesterday'
      if (days < 30) return `${days}d ago`
    }
    return d.toLocaleDateString()
  }
  const text = $derived(format(value))
</script>

{#if text}<span class="whitespace-nowrap">{text}</span>{:else}<span class="text-base-content/40">—</span>{/if}
